import * as React from 'react';
import '@styles/pages/tab3.scss';
import Master from './master.tsx';
interface AreaType {
  iArea: number,
  name: string,
}
const iArea: AreaType[] = [
  {
    iArea: 1,
    name: '游戏',
  },
  {
    iArea: 2,
    name: '娱乐',
  },
  {
    iArea: 3,
    name: '交友',
  },
  {
    iArea: 4,
    name: '陪玩',
  },
]
const Tab3: React.FC<void> = () => (
  <div className='tab3'>
    {
      iArea.map((item: AreaType, index: number) => (
        <Master key={index} {...item} />
      ))
    }
  </div>
)

export default Tab3;